import React from 'react';
import './MediaPartners.css'; // Ensure this CSS file exists
import content from '../../config/content'; // Import the media partners content

const MediaPartners = () => {
    return (
        <div className="media-partners">
            <div className="media-title">
                <h2>Partners</h2>
            </div>
            <div className="media-grid">
                {/* Map through the mediaPartners data and render images */}
                {content.mediaPartners.map((partner, index) => (
                    <img 
                        key={index}
                        src={process.env.PUBLIC_URL + partner.image} 
                        alt={partner.alt} 
                    />
                ))}
            </div>
        </div>
    );
};

export default MediaPartners;
